import { render, staticRenderFns } from "./Banner009ChupetesPararTren.vue?vue&type=template&id=09402301"
import script from "./Banner009ChupetesPararTren.vue?vue&type=script&lang=js"
export * from "./Banner009ChupetesPararTren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports